export const RELEASES_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "status", label: "Status" },
  { id: "approvedDate", label: "Data de Aprovação" },
  { id: "expectedDate", label: "Data Prevista" },
  { id: "lastStatusDate", label: "Data do Último Status" },
  { id: "executionDate", label: "Data de Execução" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
  { id: "executorId", label: "ID do Executor" },
  { id: "individualId", label: "ID do Indivíduo" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
